export default __webpack_public_path__ + "static/media/_avatar-1.997fa945.jpg";